import { render, staticRenderFns } from "./CompanySettings.vue?vue&type=template&id=27dc3de0&scoped=true&"
import script from "./CompanySettings.vue?vue&type=script&lang=js&"
export * from "./CompanySettings.vue?vue&type=script&lang=js&"
import style0 from "./CompanySettings.vue?vue&type=style&index=0&id=27dc3de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dc3de0",
  null
  
)

export default component.exports